import React from 'react';
export const LayoutRows2 = (props) => {
    const fhr = props.fullHeightRow;
    return (React.createElement("div", { style: {
            display: 'grid',
            width: '100%',
            height: '100%',
            gridTemplateRows: size(fhr === 'row1') + ' ' + size(fhr === 'row2'),
            gridTemplateColumns: '100%',
        }, "data-test": props['data-test'] },
        React.createElement("div", { style: { overflow: props.row1Scrollable ? 'auto' : fhr === 'row1' ? 'hidden' : undefined, gridRow: '1/2' }, "data-test": 'row1' }, props.row1 && props.row1),
        React.createElement("div", { style: { overflow: props.row2Scrollable ? 'auto' : fhr === 'row2' ? 'hidden' : undefined, gridRow: '2/3' }, "data-test": 'row2' }, props.row2 && props.row2)));
};
function size(full) {
    return full ? '1fr' : 'auto';
}
